import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import style from './store-status-dropdown.module.less';
import messages from '../messages';

const QueuedStatus = () => (
  <div className={classnames(style['status-message'], style['status-importing'])}>
    <div className={style['loading-indicator']} />
    <span>
      <FormattedMessage {...messages.storeStatusQueued} />
    </span>
  </div>
);

export default QueuedStatus;
